import { NotificationSearchTypeEnum } from '../enums/NotificationSearchTypeEnum';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export const notificationReadStatusOptions: ISelectOption[] = [
  {
    id: NotificationSearchTypeEnum.UNREAD,
    label: 'Непрочитанные',
    value: NotificationSearchTypeEnum.UNREAD,
    byDefault: true,
  },
  {
    id: NotificationSearchTypeEnum.ALL,
    label: 'Все',
    value: NotificationSearchTypeEnum.ALL,
  },
];

export const UNREAD_SELECT_OPTION = notificationReadStatusOptions[0];
